export default __webpack_public_path__ + "static/media/presentationFoldersHero.11da5aae.jpg";